<template>
  <div class="Setfontsize">
    <van-nav-bar :title="title" @click-left="goBack">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="content" style="margin-top:10px;">
      <!-- 右对齐 -->
      <van-row type="flex" justify="end">
        <div>
          <img round width="45px" height="45px" src="../../assets/logo.png" />
          <van-col style="float:left;">
            <div class="entry2">
              <div class="entry-trangle-right">
                <!--本Div只来实现三角形，无其他作用-->
              </div>
              <div
                class="span-content"
                :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
              >预览字体大小</div>
            </div>
          </van-col>
        </div>
      </van-row>
      <!-- 左对齐 -->
      <van-row type="flex">
        <div>
          <img round width="45px" height="45px" src="../../assets/img/icon/kefu.png" />
          <van-col style="float:right;">
            <div class="entry1">
              <div class="entry-trangle-left">
                <!--本Div只来实现三角形，无其他作用-->
              </div>
              <div
                class="span-content"
                :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
              >拖动下面的滑块，可以设置单聊和群聊聊天内容的字体大小</div>
            </div>
          </van-col>
        </div>
      </van-row>
    </div>
    <div class="windspeed_choose">
      <!-- <div class="wind_txt">
        <div id="wind_txt_value">{{WindValue}}</div>
      </div>-->
      <div class="wind_range">
        <mt-range
          class="fontsize"
          v-model="WindValue"
          :min="12"
          :max="36"
          :step="4"
          :bar-height="10"
          @input="inputEvent()"
          @change="changeEvent()"
        >
          <div slot="start" style="font-size:12px; margin-right:10px;" class="skin_color">T</div>
          <div slot="end" style="font-size:36px; margin-left:10px;" class="skin_color">T</div>
        </mt-range>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Setfontsize",
  data() {
    return {
      title: "调整字体大小",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      WindValue: localStorage.getItem("fontsize")
        ? parseInt(localStorage.getItem("fontsize"))
        : 12
    };
  },
  created() {},
  methods: {
    goBack() {
      this.$router.push({
        name: "Set",
        query: {
        }
      });
    },
    inputEvent() {},
    changeEvent() {
      localStorage.setItem("fontsize", parseInt(this.WindValue));
    }
  }
};
</script>
<style lang="less" scoped>
.wind_range{
  width:95%;
  margin-left:2.5%;
.mt-range {
  .mt-range-content {
    width:90%;
    color: #000;
	margin-left:10px;
  }
}
}
.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #ee0a24;
  border-radius: 100px;
}
.small {
  background-color: #fff;
}
.small1 {
  background-color: #429eff;
}
.mt-range-content {
  height: 20px;
  color: #000;
}
.mode_items {
  width: 100%;
  height: 10px;
  color: #000;
  display: flex;
  overflow-x: hidden;
}
.wind_auto {
  height: 100%;
  width: 23px;
  margin-left: 41px;
  align-content: center;
  margin-right: 10px;
}
.wind_auto > img {
  width: 23px;
  height: 23px;
}
.wind_range {
  height: 100%;
  // width: calc(100% - 65px);
  // margin-right: 41px;
}
.wind_txt {
  width: 100%;
  height: auto;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #666666;
  margin-bottom: 5px;
}
.content {
  margin-bottom: 0px !important;
}
// #wind_txt_value {
//   width: 40px;
//   transform: translateX(72px);
// }
</style>



// WEBPACK FOOTER //
// src/components/My/Setfontsize.vue